import { render, staticRenderFns } from "./CategoryIndex.vue?vue&type=template&id=519e8c96&scoped=true"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./CategoryIndex.vue?vue&type=style&index=0&id=519e8c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e8c96",
  null
  
)

export default component.exports